import { get, last, pipe } from 'lodash/fp';
import { upperFirst } from 'lodash';
import { both, equals, identity, ifElse, is, join, prepend } from 'ramda';
import config from '../../config';
import { prependLocationPrefix } from '../utils/routes';


export const cut = (str, length) => {
  if (!str || str.length <= length) return str;
  return `${str.slice(0, length)}...`;
};

export const firstNameAndLastInitial = (name) => {
  const [firstName, lastName] = name.split(' ');
  return `${upperFirst(firstName)} ${(upperFirst(lastName) || ' ')[0]}.`;
};

export const getCustomerPhoto = pipe(
  get('photos'),
  last,
  get('thumbnail')
);

export const getAppLinks = (brandRoute, confirmationCode) => ({
  appLink: brandRoute
    ? prependLocationPrefix(`/apps/${brandRoute}/confirmation/${confirmationCode}`)
    : prependLocationPrefix(`/apps/confirmation/${confirmationCode}`),
  ...(!brandRoute ? {
    androidLink: config.flagshipAppUrls.android,
    iosLink: config.flagshipAppUrls.ios,
  } : {}),
});

export const stripHexPrefix = (
  ifElse(
    both(
      is(String),
      pipe(
        str => str.slice(0, 2),
        equals('0x')
      ),
    ),
    str => str.slice(2),
    identity,
  )
);

export const hexToCssHex = (
  pipe(
    stripHexPrefix,
    prepend('#'),
    join(''),
  )
);

const getDirections = ({ street, street2, city, state, zip, country }) => {
  const addrStr = [street, street2, city, state, zip, country].filter(Boolean).join(', ');
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(addrStr)}`;
};

export const getShopAddress = (shop) => {
  const { street, street2, city, state, zip } = shop.address;
  const stateAndZip = [state, zip].filter(Boolean).join(' ');
  return {
    line1: [street, street2].filter(Boolean).join(', '),
    line2: [city, stateAndZip].filter(Boolean).join(', '),
    directions: getDirections(shop.address),
  };
};



// WEBPACK FOOTER //
// ./src/app/notifications/utils.js